/**
 * PCM Email Field Mirroring
 *
 * Keeps every email field on a page in sync: typing into one email input
 * fills any other empty ones (so a visitor who fills in an email on a
 * banner form doesn't have to retype it into a popup later), and on page
 * load, any email remembered from an earlier visit (via cookie) seeds
 * empty fields too. Depends on cookie-utils.js for `window.readCookie`.
 *
 * Anything seeded from the cookie is marked `data-pcm-autofilled`, which the
 * form plugin's PCMForms.capturedLeadEmail() skips. A remembered address is a
 * convenience, not proof the visitor gave it to us on this visit - without the
 * marker, seeding these fields makes the multistep modal think it already has
 * an email and skip straight to the phone step, producing leads with no
 * address on them. A value the visitor types is a real capture, so the marker
 * comes off any field that receives one.
 */
(function(window, document, $) {
  'use strict';

  function syncEmailFields(value, sourceElement) {
    const email = String(value || '').trim();

    if (!email || !$) {
      return;
    }

    $('input.email, input[name="email"]').each(function() {
      if (this === sourceElement) {
        return;
      }

      const $field = $(this);

      // Mirrors a value the visitor is typing right now, so the field it lands
      // in holds a real capture - any earlier cookie-seed marker comes off.
      if (!$field.val() || $field.attr('data-pcm-autofilled')) {
        $field.val(email).removeAttr('data-pcm-autofilled');
      }
    });
  }

  function seedEmailFieldsFromCookie() {
    const storedEmail = window.readCookie('pcm_user_email') || window.readCookie('UserEmail') || window.readCookie('email');

    if (!storedEmail || !$) {
      return;
    }

    $('input.email, input[name="email"]').each(function() {
      const $field = $(this);

      if (!$field.val()) {
        $field.val(storedEmail).attr('data-pcm-autofilled', '1');
      }
    });
  }

  function initEmailMirroring() {
    seedEmailFieldsFromCookie();

    $(document).on('input.pcmLegacyEmail change.pcmLegacyEmail', 'input.email, input[name="email"], input[type="email"]', function() {
      // The visitor is editing this field, so whatever is in it now is theirs -
      // drop the seed marker before mirroring it onward.
      $(this).removeAttr('data-pcm-autofilled');
      syncEmailFields(this.value, this);
    });
  }

  if ($ && $.fn) {
    $(initEmailMirroring);
  } else {
    document.addEventListener('DOMContentLoaded', seedEmailFieldsFromCookie);
  }
})(window, document, window.jQuery);
